<template>
  <v-row class="pb-5">
    <v-col cols="12" md="4" class="d-flex align-center">
      <p class="gray--text header-sub-modality__title mb-5 mb-md-0">
        MODALIDADE {{ nameModality }}
      </p>
    </v-col>
    <v-spacer />
    <v-col
      cols="12"
      sm="6"
      md="3"
      xl="2"
      class="pb-5 pb-sm-0"
      v-if="canSeeEditModality"
    >
      <BaseButton
        v-html="'EDITAR MODALIDADE'"
        color="secondary"
        width="100%"
        outlined
        @click="showModalEdit"
      />
    </v-col>
    <v-col cols="12" class="pb-8 pt-3">
      <v-divider />
    </v-col>
    <v-col cols="12">
      <p class="font-weight-bold mb-2 primary--text">
        SUB-MODALIDADES
      </p>
    </v-col>
    <v-col cols="12" sm="6" md="7" lg="8" class="pr-sm-5">
      <BaseFilter
        v-model="filter"
        :textPlaceholder="'Buscar'"
        v-bind="defaultConfigs"
        @search="searchByFilter"
      />
    </v-col>
    <v-col cols="12" sm="6" md="5" lg="4" v-if="canSeeNewModality">
      <BaseButton
        class="white--text secondary"
        width="100%"
        @click="showModalCreate"
      >
        <v-icon class="pr-2">
          fa-plus
        </v-icon>
        INCLUIR NOVA SUB-MODALIDADE
      </BaseButton>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
const defaultProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
export default {
  data: () => ({
    filter: null
  }),
  computed: {
    ...mapState("modality", ["currentModality"]),
    ...mapState(["userPermissions"]),
    canSeeNewModality() {
      return this.userPermissions.acoes.some(x => x.id == "criar_modalidade");
    },
    canSeeEditModality() {
      return this.userPermissions.acoes.some(x => x.id == "editar_modalidade");
    },
    nameModality() {
      return this.currentModality.nome
        ? this.currentModality.nome.toUpperCase()
        : "";
    },
    defaultConfigs() {
      return {
        ...defaultProps
      };
    }
  },
  methods: {
    showModalEdit() {
      this.$emit("edit", this.currentModality);
    },
    showModalCreate() {
      this.$emit("new");
    },
    searchByFilter() {
      this.$emit("filter", this.filter);
    }
  }
};
</script>
<style lang="sass">
.header-sub-modality__title
    font-size: 18px
    font-weight: 800
    @media(min-width: 960px) and (max-width: 1264px)
      font-size: 16px
</style>
